// app/javascript/controllers/static_search_controller.js
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["input", "results"]

  connect() {
    this.tabsjs();
    this.searchData = [
      { name: 'Hormone Testing', url: 'https://labs.findmydirectdoctor.com/hormone-testing' },
      { name: 'Annual Wellness Tests', url: 'https://labs.findmydirectdoctor.com/annual-wellness-tests' },
      { name: 'General Health Tests', url: 'https://labs.findmydirectdoctor.com/general-health-tests' },
      { name: 'Fertility / Sexual Health Tests', url: 'https://labs.findmydirectdoctor.com/fertility-sexual-health-tests' },
      { name: 'Immunity / Infectious Disease Tests', url: 'https://labs.findmydirectdoctor.com/immunity-infectious-disease-tests' },
      { name: 'Nutrition / Vitamin Health Tests', url: 'https://labs.findmydirectdoctor.com/nutrition-vitamin-health-tests' },
      { name: 'Heart Health Testing', url: 'https://labs.findmydirectdoctor.com/heart-health-testing' },
      { name: 'Allergy Testing', url: 'https://labs.findmydirectdoctor.com/allergy-testing' },
      { name: 'COVID-19 Testing', url: 'https://labs.findmydirectdoctor.com/covid-19-testing' },
      { name: 'FSA Eligible Testing', url: 'https://labs.findmydirectdoctor.com/fsa-eligible-testing' },
      { name: 'Fast Lab Testing', url: 'https://labs.findmydirectdoctor.com/fast-lab-testing' },
      { name: 'Discounted Lab Tests', url: 'https://labs.findmydirectdoctor.com/discounted-lab-tests' }
    ]
    this.selectedUrl = null
  }

  initialize() {
    this.inputTarget.addEventListener("input", () => this.search())
  }

  search() {
    const query = this.inputTarget.value.toLowerCase()
    const matches = this.searchData.filter(item => item.name.toLowerCase().includes(query))
    this.resultsTarget.innerHTML = ""

    matches.forEach(item => {
      const li = document.createElement("li")
      li.textContent = item.name
      li.classList.add("cursor-pointer", "px-4", "py-2", "hover:bg-gray-100")
      li.addEventListener("click", function () {
        this.inputTarget.value = item.name
        this.inputTarget.url = item.url
        this.resultsTarget.innerHTML = ""
      }.bind(this))
      this.resultsTarget.appendChild(li)
    })
  }

  submitSearch() {
    var url = document.getElementById('searchStaticTerm').url
    if (url) {
      window.open(url, "_blank");
    } else {
      alert("Please select a valid option from the list.")
    }
  }

  tabsjs() {
    const tabs = document.querySelector('.lab-test-wrapper');
    const tabButton = document.querySelectorAll('.test-tab-button');
    const contents = document.querySelectorAll('.test-content');

    tabs.onclick = (e) => {
      const { id } = e.target.dataset;
      if (id) {
        tabButton.forEach((btn) => {
          btn.classList.remove('job-tab-active');
        });
        e.target.classList.add('job-tab-active');
        contents.forEach((content) => {
          content.classList.remove('active');
          content.classList.add('hidden');
        });
        const element = document.getElementById(id);
        element.classList.add('active');
        element.classList.remove('hidden');
      }
    };
  }
}
